import React, { useRef, useState, useEffect } from 'react';
import moment from 'moment';
import {
  StructuredGenerate,
  DynamicDropDownInput,
  DynamicNumericInput,
  DynamicDateInput,
  DynamicTextInput,
  DynamicCheckBoxInput,
  DynamicHiddenInput,
  DynamicButtonInput
} from '../software-dynamic-version-3/mainSection-multiple-inputs-v-3';
import DynamicInputGrid from '../software-dynamic-version-3/popup-input-grid-v-3';
import {AutoCompleteComponent} from '@syncfusion/ej2-react-dropdowns'
import IssueInvoiceService from './issue-invoice.service';
import securityService from '../security/security.service';
import DropdownService from '../software-dynamic-version-3/api.service-v-3';
const IssueInvoiceAdd = (props) => {
  let { DynamicDropDownInput: DropdownComponent, DynamicNumericInput: NumberComponent, DynamicDateInput: DateComponent, DynamicTextInput: TextComponent, DynamicCheckBoxInput: CheckBoxComponent, DynamicHiddenInput: HiddenComponent, DynamicButtonInput: ButtonComponent } = { DynamicDropDownInput, DynamicNumericInput, DynamicDateInput, DynamicTextInput, DynamicCheckBoxInput, DynamicHiddenInput, DynamicButtonInput };
  console.log(props)
  // Utility to update main section values
  const updateMainSecionsValue = (valueObj) => {
    setInputProps((prevValues) => {
      const updatedValues = { ...prevValues };
      Object.keys(valueObj).forEach((key) => {
        if (updatedValues[key]) {
          updatedValues[key] = {
            ...updatedValues[key],
            ...valueObj[key],
          };
        }
      });
      return updatedValues;
    });
  };

  // State initialization for main form fields
  const [inputProps, setInputProps] = useState({
    CallBelowGridDataSource: { name: 'CallBelowGridDataSource', value: props.isAdd === false },
    SelectRowByID: { name: 'SelectRowByID', value: undefined },
    IssueInvoiceID: { name: 'IssueInvoiceID', value: props.InvoiceIssueID || undefined },
    CompanyID: { name: 'CompanyID', value: props.CompanyID || securityService.getCompanyIDLoggedInUserId() },
    StartDate: { name: 'StartDate', value: props.StartDate || '01-JAN-01'},
    IssueInvoiceDate: { name: 'IssueInvoiceDate', caption: 'Invoice Date', value: props.InvoiceIssueDate || 'currentDate' },
    CostCenter: {
      name: { id: 'CostCenterID', value: 'CostCenter' },
      caption: 'Select Cost Center',
      value: { id: props.CostCenterID , value: '' },
      dataSource: { type: 'Route', route: 'CostCenter' },
      addNew: { Route: 'FullProperty', Security: 'Full Property' }
    },
    AccountTitleExpense: {
      name: { id: 'AccountIDExpense', value: 'AccountTitleExpense' },
      caption: 'Select Expense Account',
      value: { id: props.AccountIDExpense || 'undefined', value: props.AccountTitleExpense || '' },
      dataSource: { type: 'Route', route: 'AccountIDExpense' },
      addNew: { Route: 'ExpenseAccounts', Security: 'ExpenseAccounts' },
    },
    TenantContractFSMultiDropdown:{
      name:{id:'TenantContractFSID',value:'TenantContractFSMultiDropdown'},
      caption: 'Select  Tenant Contract FS',
      value: {id: props.TenantContractFSID ,value:''},
      // dataSource: {type:'Route',route:'TenantContractFSMultiDropdown'},
      dataSource: {type:'Data',data:[]},
      //   addNew:{Route:'sldf',Security:'df'},
      isControlBlur:true,
      isMultipleColumn:true,
      multipleDropDown:{
        dataSource:[
        {field:'id', headerText:'ID' ,textAlign:'left' , size:12},
        {field:'TenantContractFSDate', headerText:'Date' ,textAlign:'right' , size:12 ,format:'DD-MMM-YY',type:'date'},
        {field:'AccountTitle', headerText:'Account Title' ,textAlign:'left' , size:12}
      ],
      showHeader:true,
    }
    },
     IssuedBy: { name: 'IssuedBy', caption: 'Issued By', value: props.ByIssued || '-' },
  });

 
  useEffect(  () => { 

    getDropdownService('TenantContractFSMultiDropdown')
    if (props.isAdd == false) {

      setTimeout(() => {
        CallBelowGridDataSources();
      }, 1500);
    }
    return () => {
      
    }
  }, []);

  const getDropdownService = async (type) => {
    try {
      const response = await DropdownService.getAllForList(type);
      if (response.data || response.data.recordset) {
          
        updateMainSecionsValue({TenantContractFSMultiDropdown:{dataSource:{type:'Data',data:response.data.recordset}}})
       } else {
        updateMainSecionsValue({TenantContractFSMultiDropdown:{dataSource:{type:'Data',data:[]}}})
      }
     } catch (error) {
      
       
    }
  }
  // Input event handlers
  const handleInputCreated = async (e, name) => {
    console.log(e);
    console.log(`Input ${name} changed to ${e}`);
  };
  const handleInputFocus = async (e, name) => {
    console.log(e);
    console.log(`Input ${name} focus to ${e}`);
  };
  const handleInputChange = async (value, name) => {
    console.log(value);
    console.log(`Input ${name} changed to ${value}`);
  };
  const handleInputBlur = async  (value, name) => {
    if(name == 'IssuedBy'){
      setTimeout(()=>document.getElementById('IssueInvoice_DetailGrid_add').click(),100)
    }
  };

  // Main section input list
  let inputsList = [
    { Input: HiddenComponent, Props: { ...inputProps.IssueInvoiceID, setInputProps }, ColumnSize: 0 },
    { Input: HiddenComponent, Props: { ...inputProps.CompanyID, setInputProps }, ColumnSize: 0 },
    { Input: DateComponent, Props: { ...inputProps.IssueInvoiceDate, setInputProps }, ColumnSize: 4 },
    { Input: DropdownComponent, Props: { ...inputProps.CostCenter, setInputProps }, ColumnSize: 4 },
    { Input: DropdownComponent, Props: { ...inputProps.AccountTitleExpense, setInputProps }, ColumnSize: 4 },
    { Input: inputProps.TenantContractFSMultiDropdown.dataSource.data.length > 0 ? DropdownComponent : HiddenComponent, Props: { ...inputProps.TenantContractFSMultiDropdown, setInputProps }, ColumnSize: 4 },
    { Input: TextComponent, Props: { ...inputProps.IssuedBy, setInputProps, onFocus:handleInputFocus,onBlur:handleInputBlur }, ColumnSize: 4 },
  ];

  // Utility to refresh below grid data source
  let CallBelowGridDataSources = () => {
    setInputProps((prevValues) => ({
      ...prevValues,
      ['CallBelowGridDataSource']: { ...prevValues['CallBelowGridDataSource'], value: true }
    }));
    setTimeout(() => {
      setInputProps((prevValues) => ({
        ...prevValues,
        ['CallBelowGridDataSource']: { ...prevValues['CallBelowGridDataSource'], value: false }
      }));
    }, 300);
  };



  let ProductNameRef = useRef(null)
const getProductNameDataSource =  async (productID)=>{
  try {
    console.log(productID)
    console.log(inputProps)
    let data ={
      CompanyID: inputProps.CompanyID.value,
      // FromDate: inputProps.FromDate.value,
      FromDate: '01-JAN-20',
      ToDate: inputProps.IssueInvoiceDate.value,
      CostCenterID:document.getElementById('CostCenterID').value || 0,
      ProductID: 0
    }
    const response = await  IssueInvoiceService.getProductStock(data)
    console.log(response.data);
      if(response.data  && response.data.recordset){
      ProductNameRef.current.dataSource = response.data.recordset
      if(productID){
      let value = response.data.recordset.filter(res => res.ProductID == productID)
      console.log(value)
      ProductNameRef.current.itemData = {...value[0] ,value : value[0].value , id :value[0].id  }
      document.getElementById('ProductNames').value = value[0].value
      }
    }
    
  } catch (error) {
    console.log(error)
  }  
}

      // SET
      const ProductNameMultiDropDown = (props)=>{
        const ddlFields: object = { value: 'value' };
        
        return(
          <div>
          <AutoCompleteComponent 
          // dataSource={saleProductNameDataSource}
          fields={ddlFields}
          name='ProductNames'
          id='ProductNames'
          ref={ProductNameRef}
          floatLabelType='Auto' 
          highlight={true}
          focus={()=>{if (ProductNameRef ) {setTimeout(() => {ProductNameRef.current.showPopup()}, 200)}}}
          itemTemplate={(data, index) => {  // Access index in the template
            console.log(data.id ==  ProductNameRef.current.dataSource[0].id)
            console.log(data)
            return (
              <table className='template-container'>
                {data.id ==  ProductNameRef.current.dataSource[0].id && ( // Render header for the first row only
                  <thead>                
                        <tr className='template-row' >
                        <th className='template-cell column-id' style={{ textAlign: 'center', color: '#5CC95E' }}>ID  </th>
                        <th className='template-cell column-ProductName' style={{ textAlign: 'center', color: '#5CC95E' }}> PRODUCT NAME </th>
                        <th className='template-cell column-StockQuantity' style={{ textAlign: 'center',width: '80px', color: '#5CC95E' }}> STOCK QUANTITY </th>
                        
                    </tr>
                  </thead>
                )}
                <tbody>
                  <tr className='template-row'>
                            <td className='template-cell  column-id'>{data.id}</td>
                            <td className='template-cell  column-ProductName'>{data.ProductName}</td>
                            <td className='template-cell  column-StockQuantity'>{data.StockQuantity.toLocaleString(undefined, {
                              minimumFractionDigits: 0,
                maximumFractionDigits: 0,
                useGrouping: true // adds the comma as a separator
            }) }</td>
                           
                  </tr>
                </tbody>
              </table>
            );
          }}

          /> 
          </div>
        )
      }
  // Grid columns for IssueInvoice_Detail
  let BelowGridColumns = [
    // { field:"ProductName",headerText:'Product',width:'200px',textAlign:'left' ,headerTextAlign:'center',other:[{'editType':'dropdownedit',edit:{
    //   caption:'Product' ,source:{type:"Route",dataSource:'Product'} , field:{id:'ProductID',value:'ProductName'}, filter:{},
    // }}] },

    { field:"ProductName",headerText:'Product Name',width:'220px' ,textAlign:'left' ,headerTextAlign:'center',other:
      [
        {
          editTemplate :(props)=>{ return(<> <ProductNameMultiDropDown {...props} /> </>)
        }
      }
    ]
  },
  
  { field:"ProductID",headerText:'Product ID',width:'220px' ,textAlign:'left' ,headerTextAlign:'center',other:[{visible:false}]},
    
    { field: "QuantityIssue", headerText: 'Quantity Issue', other: [{ endEdit:true,allowEditing: true, initialValue: 0 ,format:'n0',edit:{format:'n0'},editType:'numericedit'}] },
  ]

  // Grid event handler for calculations and save logic
  const actionComplete = async (
    grid,
    args,
    setDataSourceState,
    getListService,
    selectedRow,
    selectRowByID,
    startEdit,
    addUserLog,
    editUserLog,
    dataSourceStateLength
  ) => {
    if (args.requestType === 'add' || args.requestType === 'beginEdit') {
      setTimeout(() => { SaveButton(props.GridID, 'hidden'); }, 1000);
      document.getElementById('ProductNames').focus()
      setTimeout(()=>  {
    
      console.log(inputProps)
  getProductNameDataSource(args.rowData.ProductID)},300)
  
        console.log(args)
        
        document.getElementById('ProductNames')?.addEventListener('blur', (e)=>{
          console.log(e)
          document.getElementById('IssueInvoice_DetailGridQuantityIssue').focus()
        })
          
          document.getElementById('IssueInvoice_DetailGridQuantityIssue')?.addEventListener('focus', (e)=>{
            
              
          console.log(e)
          console.log(ProductNameRef.current)
          if(ProductNameRef.current.itemData && ProductNameRef.current.itemData.hasOwnProperty('id') && ProductNameRef.current.itemData.hasOwnProperty('value')){
          console.log(ProductNameRef.current.itemData.id)
            args.rowData.ProductID = ProductNameRef.current.itemData.id
            args.rowData.ProductNameMultiDropDown = ProductNameRef.current.itemData.value
            args.rowData.ProductName = ProductNameRef.current.itemData.value
            
            
          }
        })
      
      }
      console.log(args)


    if (args.requestType === 'save' || args.requestType === 'cancel') {
      setTimeout(() => { SaveButton(props.GridID, 'visible'); }, 1000);
    }
    if (args.requestType === 'save') {
      let mainData = {};
      setInputProps((prevValues) => {
        mainData = prevValues;
        return { ...prevValues };
      });
      let gridLength =grid.currentViewData.length

      let data = {
        // MAIN HEADER - IssueInvoice
        IssueInvoiceID: mainData.IssueInvoiceID.value,
        CompanyID: mainData.CompanyID.value,
        IssueInvoiceDate: moment(mainData.IssueInvoiceDate.value).format('DD-MMM-YY'),
        CostCenterID: mainData.CostCenter.value.id,
        AccountIDExpense: mainData.AccountTitleExpense.value.id,
        TenantContractFSID: mainData.TenantContractFSMultiDropdown.value.id,
        IssuedBy: mainData.IssuedBy.value,
        // DETAIL - IssueInvoice_Detail
        ProductID: args.rowData.ProductID,
        IssueQuantity: args.data.QuantityIssue,
        IssueInvoiceDetailID: args.data.IssueInvoiceDetailID,
        params: {
          FromDate: moment(mainData.IssueInvoiceDate.value).format('DD-MMM-YY'),
          ToDate: moment().format('DD-MMM-YY')
        },
      };
      if (args.action === 'add') {
        const response = data.IssueInvoiceID == undefined ? await IssueInvoiceService.addIssueInvoice(data) : await IssueInvoiceService.addIssueInvoiceDetail(data);
        updateMainSecionsValue({
          IssueInvoiceID: { value: response.data.IssueInvoiceID }
        });
        setDataSourceState(response.data.Recordsets.recordset);
        setTimeout(()=>document.getElementById('IssueInvoice_DetailGrid_add').click(),100)
      }

      if(args.action == 'edit' && data.IssueInvoiceID){
              const response =  await IssueInvoiceService.editIssueInvoiceDetail(data);
              console.log(response)
                
            
              setDataSourceState(response.data.Recordsets.recordset);
              setTimeout(() => {
                let  rowsInd = args.rowIndex +1;
          if(rowsInd < gridLength){
                selectRowByID(rowsInd)
                startEdit() 
         }
               }, 300);
            }
    }
  };

  // Utility to control Save button visibility
  const SaveButton = (GridID, visibility) => {
    const btn = document.querySelector(`#${GridID}Grid_dialogEdit_wrapper > .e-footer-content button.e-control.e-btn.e-lib.e-primary.e-flat`);
    if (btn) btn.style.visibility = `${visibility}`;
  };

  return (
    <div onKeyDown={(e) => e.stopPropagation()}>
      <StructuredGenerate mainProps={props} title={`Issue Invoice ${props.isAdd ? `Add` : `Edit`}`} Inputs={inputsList} />
      <DynamicInputGrid
        Id='IssueInvoice_Detail'
        ColumnsList={BelowGridColumns}
        GridDataSource={[
          {
            DataSourceType: inputProps.CallBelowGridDataSource.value === true ? 'Function' : 'REST',
            DataSource:  ()=>  IssueInvoiceService.getIssueInvoiceDetail(moment(inputProps.IssueInvoiceDate.value).format('DD-MMM-YY'),inputProps.IssueInvoiceID.value,{CompanyID:inputProps.CompanyID.value,FromDate:inputProps.StartDate.value,ToDate:moment(inputProps.IssueInvoiceDate.value).format('DD-MMM-YY'),CostCenterID:inputProps.CostCenter.value.id || 0,  ProductID:0}),
          
            // DataSource: () => IssueInvoiceService.getProductStock()(moment(inputProps.IssueInvoiceDate.value).add(1, 'days').format('DD-MMM-YY'), inputProps.IssueInvoiceID.value),
          }
        ]}
        DefaultSortedColumnName={'IssueInvoiceDetailID'}
        ListActionComplete={actionComplete}
        ToolbarClicking={(e) => { }}
        AllowTemplate={false}
        ToolbarOption={['Add', 'Edit', 'Delete', 'Update', 'Cancel']}
        AllowGrouping={false}
        AllowExcelExport={false}
        AllowPdfExport={false}
        ShowColumnChooser={false}
        AllowPaging={true}
        AllowDataBound={false}
        ListSecurity={'ListSecurity'}
        EditSecurity={true}
        DefaultSortedColumnSort={'Descending'}
        FilterColumns={[]}
        GroupColumns={[]}
        GridEditSettingMode={'Normal'}
        GridEditSettingHeaderTemplate={'<p></p>'}
        AllowGridSum={true}
        FooterSumCaption={['IssueQuantity']}
        {...props}
      ></DynamicInputGrid>
    </div>
  );
};

export default IssueInvoiceAdd;
